import {
  INetworkConfig,
  NETWORKS,
} from '@shared/constants'

import withNetworkName from './withNetworkName'

const withNetwork = (): INetworkConfig => {
  const networkName = withNetworkName()
  return NETWORKS[networkName]
}

export default withNetwork